import { useMachine } from '@xstate/react'
import { DELETEResponse } from '@cbgms/api'
import { deleteMachine } from './delete-machine'

export interface DeleteMachineOptions {
  handleDelete: (checkIfDeleteIsPossible: boolean, deleteReason?: string) => Promise<DELETEResponse>
  handleDeleteSuccess: () => Promise<void>
}

export function useDeleteMachine({ handleDelete, handleDeleteSuccess }: DeleteMachineOptions) {
  const machine = useMachine(deleteMachine, {
    services: {
      checkIfDeleteIsPossible: () => handleDelete(true),
      handleDelete: context => handleDelete(false, context.deleteReason),
      handleDeleteSuccess
    }
  })

  return machine
}
